const getSearchParamsObject = <T>(params: URLSearchParams): T => {
  let entries = [] as string[][];
  params.forEach((value, key) => {
    entries.push([key, value]);
  });
  const searchParams = entries.reduce(
    (acc, cur) => ({ ...acc, [cur[0]]: cur[1] }),
    {} as T
  );

  return searchParams;
};

export default getSearchParamsObject;
